export const MENU_HASH = {
  OVERVIEW: 'subnav-overview',
  TRIM_SUMMARY_DESKTOP: 'subnav-trim-summary-desktop',
  TRIM_SUMMARY_MOBILE: 'subnav-trim-summary-mobile',
  REVIEWS: 'subnav-reviews',
  RATING_SCORECARD: 'subnav-rating-scorecard',
  CONSUMER_REVIEWS: 'consumer-reviews',
  PRICING: 'subnav-pricing',
  FOR_SALE: 'for-sale',
  FEATURES: 'subnav-features',
  COMPETITION: 'subnav-competition',
  SAFETY: 'safety',
  EV_INSIGHTS: 'ev-insights',
  COST_TO_DRIVE: 'cost-to-drive',
  VIDEOS: 'videos',
  RELIABILITY: 'reliability',
  PRICE_HISTOGRAM: 'price-and-payment-histogram',
  PROS_CONS: 'pros-cons',
  WHATS_NEW: 'whats-new',
  MODEL_OVERVIEW: 'model-overview',
  DRIVING: 'driving',
  COMFORT: 'comfort',
  INTERIOR: 'interior',
  TECHNOLOGY: 'technology',
  UTILITY: 'utility',
  MPG: 'mpg',
  VALUE: 'value',
  WILDCARD: 'wildcard',
  REVIEW_SAFETY: 'review-safety',
  STORAGE: 'storage',
  TOW_HAUL: 'tow-haul',
  X_FACTOR: 'x-factor',
  TRIM_DESCRIPTIONS: 'trim-descriptions',
  RECOMMENDED_TRIM: 'recommended-trim',
  FEATURES_SPECS: 'features-and-specs',
  VERDICT: 'verdict',
  BUYING_TIPS: 'buying-tips',
  PRICE_CHECKER: 'price-checker',
  FAQS: 'faqs',
};
